export const icsIncidentLocationsKeys = {
  all: () => ['ics_incident_locations'] as const,
  get: (id: UUID) => [...icsIncidentLocationsKeys.all(), id] as const,
};
